import "./Image.scss";

import React from "react";
import classNames from "classnames";
import { RiCloseCircleFill } from "react-icons/ri";
import {useAccount, useLayerPopupContext} from "../../contexts";
import {GROUP} from "../../config";

interface Props {
  src: string;
}

const Image = () => {
  const { account } = useAccount();
  const { image: { url}, close } = useLayerPopupContext();

  const isStreamerGroup = GROUP.STREAMER.includes(account.viewer!.role);

  return (
    <article
      className={"modal--contents--image"}
    >
      <RiCloseCircleFill
        className="modal--close"
        onClick={() => {
          close();
        }}
      />
      <img
        src={url}
        alt="popupImage"
        className={classNames({ie: isStreamerGroup})}
      />
    </article>
  );
};

export default Image;
